import { render, staticRenderFns } from "./SortBySelector.vue?vue&type=template&id=5bec3d6a&scoped=true"
import script from "./SortBySelector.vue?vue&type=script&lang=js"
export * from "./SortBySelector.vue?vue&type=script&lang=js"
import style0 from "./SortBySelector.vue?vue&type=style&index=0&id=5bec3d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec3d6a",
  null
  
)

export default component.exports